/**
 * OAuth callback constants
 */

/** App URL scheme for deep links (must match app.config.js scheme) */
export const NATIVE_OAUTH_SCHEME = 'zporti';

/** Native OAuth redirect URL (Supabase redirects here after provider sign-in) */
export const NATIVE_OAUTH_REDIRECT_URL = 'zporti://oauth-native-callback';

/** Native OAuth redirect after session is complete */
export const NATIVE_OAUTH_REDIRECT_COMPLETE = 'zporti://app/';

/** Web: sessionStorage key to persist sign_up vs sign_in before OAuth redirect (read in callback) */
export const OAUTH_FLOW_STORAGE_KEY = 'zporti_oauth_flow';

/** Web: safe post-auth path (same rules as returnUrl) — read on /oauth-native-callback after provider redirect */
export const OAUTH_POST_AUTH_PATH_STORAGE_KEY = 'zporti_oauth_post_auth_path';

/** Web: provider + options to silently restart OAuth after consumed auth code (corporate proxy prefetch). */
export const OAUTH_RESTART_CONFIG_STORAGE_KEY = 'zporti_oauth_restart_config';

/** Web: guard so silent auto-retry runs at most once per user-initiated OAuth click. */
export const OAUTH_AUTO_RETRY_ATTEMPTED_STORAGE_KEY = 'zporti_oauth_auto_retry_attempted';

/** Web: sessionStorage value = auth `code` currently being exchanged (prevents double PKCE exchange). */
export const OAUTH_PKCE_EXCHANGE_LOCK_STORAGE_KEY = 'zporti_oauth_pkce_exchange_lock';

/**
 * Passed to Google via Supabase `signInWithOAuth` so users always see the account picker
 * instead of being signed in to the default browser Google session with no choice.
 */
export const GOOGLE_OAUTH_QUERY_PARAMS: Record<string, string> = {
  prompt: 'select_account',
}

/**
 * Returns Google OAuth query params with an `hd` (hosted domain) hint for company sign-in.
 * The `hd` param is a UX hint only — it pre-filters the Google account picker to the company domain.
 * Real access control is enforced server-side via allowedEmailDomain (not by this param).
 */
export const B2B_GOOGLE_OAUTH_QUERY_PARAMS = (domain: string): Record<string, string> => ({
  prompt: 'select_account',
  hd: domain,
});

export const REDIRECT_DELAY_MS = 1000 // For success states
export const ERROR_REDIRECT_DELAY_MS = 0 // Immediate redirect for errors

// Error message mapping for user-friendly display
export const ERROR_MESSAGES: Record<string, { message: string; isCancellation: boolean }> = {
  access_denied: { message: 'Login cancelled', isCancellation: true },
  invalid_request: { message: 'Invalid request. Please try again.', isCancellation: false },
  server_error: { message: 'Server error. Please try again later.', isCancellation: false },
  temporarily_unavailable: {
    message: 'Service temporarily unavailable. Please try again later.',
    isCancellation: false,
  },
}

